import React from 'react';

import { Section, Alert } from '@gogame/components';
import { withForm, SidePageV2, FormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import MoveCreativeToConceptForm from 'scenes/Gallery/GalleryPage/Concepts/MoveCreativeToConceptForm';
import { APPLICATIONS } from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import CreativeTile from 'scenes/Gallery/GalleryPage/Creatives/CreativesDataTable/CreativeTile';
import { loadConcepts } from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';
import { CONCEPT_ID, CREATIVE_ID } from 'scenes/Gallery/GalleryPage/constants';

const MoveToForm = withForm({
  enableReinitialize: true,
})(({ loading, onClose, creative, onExited, onAddConcept, values, open }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleAdd = () => {
    return new Promise((resolve) => {
      openChildComponent(MoveCreativeToConceptForm, {
        id: values[CREATIVE_ID],
        onSubmit: (concept) => {
          onClose();
          onAddConcept(concept);
          resolve(concept);
        },
      });
    });
  };

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'sm'}
    >
      <SidePageV2.Title title={'Move to Another Concept'} />
      <SidePageV2.NewBody wrapper={true}>
        <SidePageV2.NewContent withSidebar={true}>
          <Alert severity={'info'}>
            The creative data history will be saved
          </Alert>
          <Section title={'Destination'}>
            <FormField.Select
              name={CONCEPT_ID}
              label={'Concept'}
              source={loadConcepts}
              depends={[APPLICATIONS]}
              addOptionLabel={'Concept'}
              onAdd={handleAdd}
              helper={`Filtered by the current concept’s applications`}
              required={true}
              padding={0}
            />
          </Section>
          <Section title={'Selected Creative'}>
            {creative ? (
              <CreativeTile data={creative} withActions={false} />
            ) : null}
          </Section>
        </SidePageV2.NewContent>
      </SidePageV2.NewBody>

      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton>Move</SidePageV2.SubmitButton>
      </SidePageV2.Actions>
      {childComponent}
    </SidePageV2>
  );
});

export default MoveToForm;
